import React, { useEffect, useRef } from 'react';
import { StyledAlert, StyledChildrenContainer, StyledDialog, StyledIconButton, StyledInner } from './index.styles.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { useFocusTrap } from '../../utils/use-focus-trap.js';
export const Dialog = ({ children, padding = true, open, triggerButton, variant, dialogAriaProps, onCloseButtonAriaLabel, onClose, className, ...rest }) => {
    const dialogRef = useRef(null);
    const triggerRef = useRef(null);
    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };
    const handleBackdropClick = (event) => {
        if (!onClose)
            return;
        /* This logic only works because the direct child <div> of <dialog>
         ** takes all the space within the <dialog> container. When <dialog> has a padding,
         ** the click detection also fires on that padding area.
         */
        if (dialogRef.current && event.target === dialogRef.current) {
            onClose();
        }
    };
    useFocusTrap({
        open,
        ref: dialogRef,
        triggerRef
    });
    useEffect(() => {
        const element = dialogRef.current;
        if (!element)
            return;
        element.addEventListener('cancel', handleClose);
        element.addEventListener('click', handleBackdropClick);
        if (open) {
            element.showModal();
        }
        else {
            element.close();
        }
        return () => {
            element.removeEventListener('cancel', handleClose);
            element.removeEventListener('click', handleBackdropClick);
        };
    }, [open]);
    return (React.createElement(React.Fragment, null,
        triggerButton && React.cloneElement(triggerButton, { ref: triggerRef }),
        React.createElement(StyledDialog, { ...pickDataProps(rest), ...pickA11yProps(rest), ref: dialogRef, "aria-describedby": dialogAriaProps?.ariaDescribedBy, "aria-labelledby": dialogAriaProps?.ariaLabelledBy, variant: variant, hasPadding: padding, className: className }, variant === 'alert' ? (padding ? (React.createElement(StyledAlert, null, children)) : (children)) : (React.createElement(StyledInner, null,
            React.createElement(StyledIconButton, { hasPadding: padding, "aria-label": onCloseButtonAriaLabel, variant: "tertiary", icon: "cancel", onClick: handleClose, size: "xs" }),
            React.createElement(StyledChildrenContainer, null, children))))));
};
Dialog.displayName = 'Dialog';
//# sourceMappingURL=index.js.map